import IAsset from "../../../models/IAsset";

interface SmartObjectAssetPreviewProps {
  data: IAsset;
}

export default function SmartObjectAssetPreview({ data }: Readonly<SmartObjectAssetPreviewProps>) {
  if (!data || !data.smartObject) return <div>No Preview Available</div>;

  const svgPath = `/api/Asset/${data.blobPath}/${data.smartObject.smartObjectSvg.toLowerCase().replaceAll(" ", "_")}`;

  return (
    <div>
      <img src={svgPath} alt={data.smartObject.smartObjectSvg} />
    </div>
  );
}
